import type { SharedProps } from '@bonniernews/dn-design-system-web/assets/types/shared-props.ts'

import { VisuallyHidden } from '@bonniernews/dn-design-system-web/foundations/a11y/visually-hidden.tsx'

import { formatClassString } from '@bonniernews/dn-design-system-web/helpers/formatClassString.ts'

export interface VideoCaptionProps extends SharedProps {
  /** Ex: "Detta är en bildtext" */
  caption?: string
  /** Ex: "01:23" */
  duration?: string
  forcePx?: boolean
}

/**
 * - GitHub: [BonnierNews/dn-design-system/web/src/components/video-caption](https://github.com/BonnierNews/dn-design-system/tree/main/web/src/components/video-caption)
 * - Storybook: [VideoCaption](https://designsystem.dn.se/?path=/docs/article-videocaption--docs)
 *
 * The component will not include styling by itself. Make sure to include the right styles for the component. See example below:
 * `@use '@bonniernews/dn-design-system-web/components/video-caption/video-caption.scss'`
 */
export const VideoCaption = ({ caption, duration, classNames, attributes, forcePx }: VideoCaptionProps) => {
  const classes = formatClassString(['ds-video-caption', forcePx && 'ds-force-px', classNames])

  return (
    <figcaption className={classes} {...attributes}>
      {duration && (
        <>
          <span className='ds-video-caption__duration' aria-hidden='true'>
            {duration}
          </span>
          <VisuallyHidden text={`Videon är ${duration} lång.`} />
        </>
      )}
      {caption && <span className='ds-video-caption__text'>{caption}</span>}
    </figcaption>
  )
}
